import TextSwitcher from "./TextSwitcher";

export default TextSwitcher;
